// Helper per contenuti testuali provenienti dal CMS/DB (rich text).

/**
 * Rimuove i tag HTML da una stringa, restituendo solo il testo.
 *
 * Da usare nei contesti PLAIN-TEXT — placeholder, attributi, label corte,
 * anteprime e card — dove l'HTML non può/non deve essere renderizzato.
 * Su una stringa già senza tag ritorna il valore invariato.
 *
 * Per i contesti "block" (descrizioni lunghe, pagine) usare invece il
 * componente <RichText/>, che sanifica e renderizza l'HTML.
 */
export function stripHtml(html: string | null | undefined): string {
  if (!html) return "";
  if (!/<[a-z][\s\S]*>/i.test(html)) return html;
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || "").trim();
}
